import React from "react";
import classNames from "../../utils/classNames";

export default function PageContainer(props) {
  const { children, className } = props;
  return <main className={classNames(className, "md:py-7 md:px-0 px-5 py-5 max-w-5xl mx-auto main")}>{children}</main>;
}
